module.exports = __webpack_public_path__ + "static/phone_layer-fc5aab7d2a5d176010b4c812d95d05c3.png";